<template>
  <div
    class="maps"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- <div class="title">中物数智云仓</div> -->
    <div class="heard">
      <!-- <router-link to="/wms/logisticsDisplaySmall"> </router-link> -->
      <!-- <div class="img">
            <img src="../../../assets/dapingImg/logo.png" alt @click="goTo"/>
        </div> -->

      <span class="title">{{ name }}</span>
      <div class="chepaiInput">
        <el-input style="width: 130px" v-model="inputX" placeholder="请输入x">
        </el-input>
        <el-input style="width: 130px" v-model="inputY" placeholder="请输入y">
        </el-input>
        <el-button size="small" type="text" @click="animate">查询</el-button>
      </div>
      <div class="date">
        <div><span class="span1"></span>参考定位</div>
        <div><span class="span2"></span>正常在库</div>
        <div><span class="span3"></span>预出货物</div>
        <b
          ><el-button type="primary" size="mini" @click="goTo"
            >返回</el-button
          ></b
        >
        <b
          ><el-button
            type="primary"
            size="mini"
            @click="shuaxin"
            style="marginleft: 10px"
            >刷新</el-button
          ></b
        >
      </div>
    </div>
    <div class="content">
      <!-- 顶视图 -->
      <div class="top" ref="pageContainer">
        <div
          class="divCenter"
          id="divCenter"
          :style="{
            width: width + 'px',
            height: height + 'px',
            border: '1px solid #03f6e2',
          }"
        >
          <template v-for="(item, index) in quweiList">
            <div
              class="biankuang"
              id="biankuang"
              :style="{
                height: (item.rightY - item.leftY) * item.w + 'px',
                lineHeight: (item.rightY - item.leftY) * item.w + 'px',
              }"
            >
              {{ item.locationName }}
            </div>
          </template>

          <div
            class="gangjuan"
            id="gangjuan"
            v-for="(item, index) in gangjuanList"
          >
            <div
              :style="{
                left: item.leftX * item.w + 'px',
                top: item.leftY * item.w + 'px',
                width: (item.rightX - item.leftX) * item.w + 'px',
                height: (item.rightY - item.leftY) * item.w + 'px',
              }"
              :class="[
                item.state == 0 ? 'b1' : item.state == 1 ? 'active' : 'active1',
              ]"
              @click="juanClick(item, index)"
            ></div>
          </div>
          <div
            class="xianshiSolid"
            ref="xianshiSolid"
            id="xianshiSolid"
            v-if="solidFlag"
          ></div>
          <!-- 天车 -->  <!-- 上圆 --><!-- 中间 --><!-- 下圆 -->
          <!-- <div class="tianche" id="tianche">

            <div class="circle1"></div>

            <div class="circle2" id="circle2"></div>

            <div class="circle3"></div>
          </div> -->
          <div class="hezi"></div>
        </div>
      </div>
      <div class="center"></div>
      <!-- 前视图 -->
      <div class="bottom" ref="bottom">
        <div
          class="pingJuan"
          :style="{
            width: width + 'px',
          }"
        >
          <div class="one">
            <div
              class="ul"
              v-for="(i, d) in number"
              :key="d"
              :style="{ position: 'relative', height: maxLength + 'px'}"
            >
              <template
                v-for="(item3, index3) in pingJuanList"
                v-if="item3.layer == i"
                :style="{
                  width: width + 'px',
                }"
              >
                <el-popover
                  placement="top"
                  title="货物信息"
                  width="280"
                  trigger="click"
                >
                  <div>
                    捆包号：{{ popoverList.cargoBarcode }}<br />货物类型：{{
                      popoverList.productTypeName
                    }}<br />层级：{{ popoverList.layer }}层<br />
                    品名：{{ popoverList.productName }}<br />材质：{{
                      popoverList.model
                    }}<br />
                    规格：{{ popoverList.specification }}<br />重量：{{
                      popoverList.weight
                    }}<br />
                    合同号：{{ popoverList.agreementNumber }}<br />合约号：{{
                      popoverList.contractNumber
                    }}<br />
                    所属客户：{{ popoverList.customerName }}<br />
                    入库时间：{{ popoverList.createTime | dateFormat }}<br />
                    坐标信息：({{ popoverList.coordinateX }},{{
                      popoverList.coordinateY
                    }})<br />
                  </div>
                  <div
                    slot="reference"
                    @click="pingClick(item3, index3)"
                    :class="[
                      item3.state == 0
                        ? 'b1'
                        : item3.state == 1
                        ? 'active'
                        : 'active1',
                    ]"
                    v-show="item3.state !== 1 && item3.layer == i"
                    :style="{
                      left: item3.leftX * item3.w + 'px',
                      width: (item3.rightX - item3.leftX) * item3.w - 8 + 'px',
                      height: (item3.rightX - item3.leftX) * item3.w - 8 + 'px',
                    }"
                  >
                    <b
                      class="el-icon-help"
                      :style="{
                        fontSize:
                          (item3.rightX - item3.leftX) * item3.w - 8 + 'px',
                      }"
                      v-if="item3.icon == 1"
                    ></b>
                  </div>
                </el-popover>
                <el-popover
                  placement="top"
                  title="货物信息"
                  width="280"
                  trigger="click"
                >
                  <div>
                    捆包号：{{ popoverList.cargoBarcode }}<br />货物类型：{{
                      popoverList.productTypeName
                    }}<br />层级：{{ popoverList.layer }}层<br />
                    品名：{{ popoverList.productName }}<br />材质：{{
                      popoverList.model
                    }}<br />
                    规格：{{ popoverList.specification }}<br />重量：{{
                      popoverList.weight
                    }}<br />
                    合同号：{{ popoverList.agreementNumber }}<br />合约号：{{
                      popoverList.contractNumber
                    }}<br />
                    所属客户：{{ popoverList.customerName }}<br />
                    入库时间：{{ popoverList.createTime | dateFormat }}<br />
                    坐标信息：({{ popoverList.coordinateX }},{{
                      popoverList.coordinateY
                    }})<br />
                  </div>
                  <div
                    slot="reference"
                    @click="pingClick(item3, index3)"
                    :class="[
                      item3.state == 0
                        ? 'b1'
                        : item3.state == 1
                        ? 'active'
                        : 'active1',
                    ]"
                    v-show="item3.state !== 0 && item3.layer == i"
                    :style="{
                      left: item3.leftX * item3.w + 'px',
                      width: (item3.rightX - item3.leftX) * item3.w - 8 + 'px',
                      height: (item3.rightX - item3.leftX) * item3.w - 8 + 'px',
                    }"
                  >
                    <b
                      class="el-icon-help"
                      v-if="item3.icon == 1"
                      :style="{
                        fontSize:
                          (item3.rightX - item3.leftX) * item3.w - 8 + 'px',
                      }"
                    ></b>
                  </div>
                </el-popover>
              </template>
            </div>
          </div>
          <div
            class="xianshiLayer"
          >
            <div v-if="oneLenght > 0" style="width: 300rpx; display: flex">
              <div style="width: 130rpx">第一层:</div>
              <div style="width: 140rpx; text-align: left">{{ oneLenght }}</div>
            </div>
            <div v-if="twoLenght > 0" style="width: 300rpx; display: flex">
              <div style="width: 130rpx">第二层:</div>
              <div style="width: 140rpx; text-align: left">{{ twoLenght }}</div>
            </div>
            <div v-if="threeLenght > 0" style="width: 300rpx; display: flex">
              <div style="width: 130rpx">第三层:</div>
              <div style="width: 140rpx; text-align: left">
                {{ threeLenght }}
              </div>
            </div>
            <div v-if="fourLenght > 0" style="width: 300rpx; display: flex">
              <div style="width: 130rpx">第四层:</div>
              <div style="width: 140rpx; text-align: left">
                {{ fourLenght }}
              </div>
            </div>
            <div v-if="fiveLenght > 0" style="width: 300rpx; display: flex">
              <div style="width: 130rpx">第五层:</div>
              <div style="width: 140rpx; text-align: left">
                {{ fiveLenght }}
              </div>
            </div>
          </div>
          <!-- 天车 --><!-- 上圆 --><!-- 中间 --><!-- 下圆 -->
          <!-- <div class="tianche" id="tiancheBot">

            <div class="circle1"></div>

            <div class="circle2" id="circle2Bot" v-if="this.tiancheFlag"></div>

            <div class="circle3"></div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  findPositionForAI
  // getCargoCoordinateListForPosition
} from '@/api/wms-stock'
import {
  positionTianChe,
  getCargoCoordinateListForWhId,
  getYCargoListForLeftToRight
} from '@/api/wms-access'
import dateFormat from '../../../utils/Date'

export default {
  data () {
    return {
      listOne: [],
      listTwo: [],
      listThree: [],
      listFour: [],
      listFive: [],

      oneLenght: 0,
      twoLenght: 0,
      threeLenght: 0,
      fourLenght: 0,
      fiveLenght: 0,
      item: {},
      cargoBarcode: '',
      inputX: '',
      inputY: '',
      widthox: '230px',
      width: '900',
      height: '500',
      x: '', // 出库主列表
      y: '', // 出库主列表
      z: '', // 出库主列表
      w: '', // 出库主列表
      equipmentTag: '', // 出库主列表
      positionX: '', // 出库主列表
      positionY: '', // 出库主列表
      widthLength: '0px',
      chepaiInput: '',
      flag: true, // 钢卷信息显示
      solidFlag: false, // 钢卷信息显示
      tiancheFlag: false, // 钢卷信息显示
      visible: false, // 钢卷信息显示
      itemFlag: false, // 钢卷信息显示
      noFlag: false, // 钢卷信息显示
      list: [], // 钢卷信息显示
      lengthList: [], // 钢卷信息显示
      number: [], // 仓库id
      maxLength: 0, // 仓库id
      cargoNumber: '', // 仓库id
      id: '', // 仓库id
      name: '', // 仓库id
      xinxi: '', // 仓库id
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      shijian: '', // 当前时间
      nowWeek: '', // 当前星期
      churutableData: [], // 出入库数据
      loading: false,
      inputVlaue: '',
      quMark: false,
      popoverList: {},
      quweiList: [],
      pingJuanList: [],
      gangjuanList: []
    }
  },
  computed: {
    classOption () {
      return {
        // step: 0.005,
        step: 0.015,
        // step: 0.3,
        limitMoveNum: 1, // 这个是修改moveSwitch()之前的使用方法，这里的数值指的是数据条数
        // limitMoveNum: this.churutableData.length,
        openTouch: false,
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  filters: {
    formatDate (time) {
      let date = new Date(time)
      return dateFormat.formatDate(date, 'MM.dd hh:mm')
    },
    formatDate1 (time) {
      let date = new Date(time)
      return dateFormat.formatDate(date, 'yyyy.MM.dd hh:mm')
    }
  },
  created () {
    this.id = this.$route.query.id // 接受参数关键代码
    this.name = this.$route.query.name // 接受参数关键代码
    this.x = this.$route.query.x // 接受参数关键代码
    this.y = this.$route.query.y // 接受参数关键代码
    this.z = this.$route.query.z // 接受参数关键代码
    this.equipmentTag = this.$route.query.equipmentTag // 接受参数关键代码
    this.positionX = this.$route.query.positionX // 接受参数关键代码
    this.positionY = this.$route.query.positionY // 接受参数关键代码
    this.width = ''
    this.height = ''
    this.w = ''
    this.positionTianCheS()

    this.$nextTick(() => {
      this.w = (
        parseInt(this.$refs.pageContainer.offsetWidth) / parseInt(this.x)
      ).toFixed(2)
      this.width = parseInt(this.x * this.w)
      this.height = parseInt(this.y * this.w)
      this.animate()
    })
    this.findPositionForAIS()
    this.getCargoCoordinateListForWhIdS()

    if (this.cargoNumber > 0) {
      this.widthox =
        Math.ceil(parseInt(this.widthox) / 12) * parseInt(this.cargoNumber) +
        'px'
    }

    // this.timer = setInterval(() => {
    //   this.positionTianCheS()
    // }, 500)
  },
  destroyed () {
    if (this.timer) {
      // 注意在vue实例销毁前，清除我们的定时器
      clearInterval(this.timer)
    }
  },
  methods: {
    shuaxin () {
      this.getCargoCoordinateListForWhIdS()
      this.pingJuanList = []
    },
    // 点击返回
    goTo () {
      this.$router.push({
        path: '/wms/logisticsDisplaySmall',
        query: {
          id: this.id,
          name: this.name,
          equipmentTag: this.equipmentTag,
          z: this.z,
          x: this.x,
          y: this.y
        }
      })
    },
    // 天车
    positionTianCheS () {
      positionTianChe({
        equipmentTag: this.equipmentTag
      })
        .then((res) => {
          this.tiancheList = res
          var box1 = document.getElementById('tianche')
          var circle21 = document.getElementById('circle2')
          box1.style.left = this.tiancheList.positionX * this.w + 'px'
          circle21.style.top = this.tiancheList.positionY * this.w - 10 + 'px'
          // 平面
          var tiancheBot = document.getElementById('tiancheBot')
          tiancheBot.style.left = this.tiancheList.positionX * this.w + 'px'
          // 在钢卷范围内
          // 天车位于钢卷一定范围内，显示对应平面leftY+50 rightY-50
          var left1 = parseInt((this.item.leftY - 50) * this.w)
          var right1 = parseInt((this.item.rightY + 50) * this.w)
          var positionY = this.tiancheList.positionY * this.w - 10
          if (positionY >= left1 && positionY <= right1) {
            this.tiancheFlag = true
          } else {
            this.tiancheFlag = false
          }
        })
        .catch((err) => {
          // DonMessage.error(err.message);
          console.log(err)
        })
    },
    animate () {
      document.getElementById('tianche').style.top = 0 + 'px'
      document.getElementById('circle2').style.left = -7.5 + 'px'
      if (this.inputX !== '' && this.inputY !== '') {
        var inputX = parseInt(this.inputX * this.w)
        var inputY = parseInt(this.inputY * this.w)
        //  俯视
        var box = document.getElementById('tianche')
        var div2 = document.getElementById('divCenter')
        var circle2 = document.getElementById('circle2')
        var div2Width = parseInt(div2.style.width)
        box.style.left = inputX + 'px'
        circle2.style.top = inputY - 10 + 'px'
        // 平面
        var tiancheBot = document.getElementById('tiancheBot')
        tiancheBot.style.left = inputX + 'px'
        // -------------------------------------------------------------------------

        // 天车位于钢卷一定范围内，显示对应平面leftY+50 rightY-50
        var left = parseInt((this.item.leftY - 50) * this.w)
        var right = parseInt((this.item.rightY + 50) * this.w)

        // 在钢卷范围内
        if (inputY >= left && inputY <= right) {
          this.tiancheFlag = true

          if (inputX > div2Width / 2) {
            // 滚动条高度-俯视
            this.$nextTick(() => {
              this.$refs.pageContainer.scrollTop = 0
              this.$refs.pageContainer.scrollLeft = 0
              this.$refs.pageContainer.scrollTop = inputY / 2
              this.$refs.pageContainer.scrollLeft = inputX / 2
            })
            // 滚动条高度-平面
            this.$nextTick(() => {
              this.$refs.bottom.scrollLeft = inputX
            })
          } else {
            this.$refs.pageContainer.scrollLeft = 0
            this.$refs.bottom.scrollLeft = 0
          }
        } else {
          this.tiancheFlag = false
          // this.pingJuanList = []
        }
        if (tiancheBot.style.left !== 0) {
          this.tiancheFlag = true
        }
      } else {
        var box1 = document.getElementById('tianche')
        var circle21 = document.getElementById('circle2')
        box1.style.left = this.positionX * this.w + 'px'
        circle21.style.top = this.positionY * this.w - 10 + 'px'
        // 平面
        var tiancheBot1 = document.getElementById('tiancheBot')
        tiancheBot1.style.left = this.positionX * this.w + 'px'

        // 滚动条高度-俯视
        this.$nextTick(() => {
          this.$refs.pageContainer.scrollTop = 0
          this.$refs.pageContainer.scrollLeft = 0
          this.$refs.pageContainer.scrollTop = (this.positionY * this.w) - 200
          this.$refs.pageContainer.scrollLeft = this.positionX * this.w
        })
        // 滚动条高度-平面
        this.$nextTick(() => {
          this.$refs.bottom.scrollLeft = this.positionX * this.w
        })
      }
    },
    // 平面-点击钢卷
    pingClick (item, index) {
      this.popoverList = {}
      this.popoverList = item
      this.pingJuanList.forEach((item, index) => {
        item.icon = 0
      })
      this.pingJuanList[index].icon = 1
    },
    // 俯视-点击钢卷
    juanClick (item, index) {
      this.item = item
      this.solidFlag = true

      getCargoCoordinateListForWhId({
        warehouseId: this.id
      })
        .then((res) => {
          this.gangjuanList = res
          this.gangjuanList.forEach((item, index) => {
            item.w = this.w
          })
          this.gangjuanList[index].state = 100
          this.cargoBarcode = this.gangjuanList[index].cargoBarcode
          // 在钢卷范围内
          // 天车位于钢卷一定范围内，显示对应平面leftY+50 rightY-50
          var left = parseInt((item.leftY - 50) * this.w)
          var right = parseInt((item.rightY + 50) * this.w)
          var positionY = this.tiancheList.positionY * this.w - 10
          if (positionY >= left && positionY <= right) {
            this.tiancheFlag = true
          } else {
            this.tiancheFlag = false
          }

          getYCargoListForLeftToRight({
            warehouseId: this.id,
            leftY: item.leftY,
            rightY: item.rightY
          })
            .then((res) => {
              this.pingJuanList = []
              this.number = []
              this.pingJuanList = res
              // if (this.pingJuanList.length !== 0) {
              //   this.tiancheFlag = true
              // }
              var arr = []
              var b = []
              var a = null

              this.pingJuanList.forEach((item, index) => {
                if (this.cargoBarcode == item.cargoBarcode) {
                  item.state = 100
                }

                item.w = this.w
                arr.push(item.layer)
                b.push((item.rightX - item.leftX) * item.w)
                a = Math.max(...arr)
                this.maxLength = Math.min(...b)
              })
              for (var i = 1; i <= a; i++) {
                this.number.unshift(i)
              }
              this.oneLenght = 0
              this.twoLenght = 0
              this.threeLenght = 0
              this.fourLenght = 0
              this.fiveLenght = 0
              this.listOne = []
              this.listTwo = []
              this.listThree = []
              this.listFour = []
              this.listFive = []

              this.pingJuanList.forEach((item, index) => {
                if (item.layer == 1) {
                  console.log('item.layer==1')
                  this.listOne.push(item)
                } else if (item.layer == 2) {
                  this.listTwo.push(item)
                } else if (item.layer == 3) {
                  this.listThree.push(item)
                } else if (item.layer == 4) {
                  this.listFour.push(item)
                } else if (item.layer == 5) {
                  this.listFive.push(item)
                }
              })
              this.oneLenght = this.listOne.length
              this.twoLenght = this.listTwo.length
              this.threeLenght = this.listThree.length
              this.fourLenght = this.listFour.length
              this.fiveLenght = this.listFive.length
              var xianshiSolid = document.getElementById('xianshiSolid')

              xianshiSolid.style.top = (item.leftY - 50) * this.w + 'px'
              xianshiSolid.style.height =
                (item.rightY + 50) * this.w - (item.leftY - 50) * this.w + 'px'
              this.$forceUpdate()
            })
            .catch((err) => {
              // DonMessage.error(err.message);
              console.log(err)
            })
        })
        .catch((err) => {
          console.log(err)
        })
      // console.log(this.$refs.pageContainer.scrollLeft, 'this.$refs.pageContainer.scrollLeft')
      if (this.$refs.pageContainer.scrollTop !== 0) {
        this.$refs.bottom.scrollLeft = this.$refs.pageContainer.scrollLeft
      }
    },
    // 出库货物信息主数据-钢卷
    getCargoCoordinateListForWhIdS () {
      getCargoCoordinateListForWhId({
        warehouseId: this.id
      })
        .then((res) => {
          this.gangjuanList = res
          this.gangjuanList.forEach((item, index) => {
            item.w = this.w
          })
        })
        .catch((err) => {
          // DonMessage.error(err.message);
          console.log(err)
        })
    },
    // 区位信息
    findPositionForAIS () {
      findPositionForAI({
        warehouseId: this.id
      })
        .then((res) => {
          this.quweiList = res
          this.quweiList.forEach((item, index) => {
            item.w = this.w
          })
          console.log(this.w, ' this.w')
        })
        .catch((err) => {
          // DonMessage.error(err.message);
          console.log(err)
        })
    },
    // 获取当前时间
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      hh = hh < 10 ? '0' + hh : hh
      let ff = new Date().getMinutes()
      ff = ff < 10 ? '0' + ff : ff
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '年' + mm + '月' + dd + '日'
      _this.shijian = hh + ':' + ff
    }
  }
}
</script>
<style lang="scss" scoped>
.heard {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  display: flex;
  // background: url("../../../assets/dapingImg/标题光条.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  position: relative;
  .title {
    position: absolute;
    left: 30px;
    font-size: 30px;
    // font-weight: 700;
    color: #03faec;
  }
  .chepaiInput {
    height: 6vh;
    line-height: 6vh;
    position: absolute;
    left: 220px;
    display: flex;
    // margin-top: 2vh;
    .el-button {
      margin-left: 20px;
      margin-right: 20px;
      height: 40px;
      // line-height: 40px;
      //   background-color: #fff;
      font-size: 25px;
      font-weight: 700;
    }
  }
  .date {
    width: 400px;
    height: 6vh;
    line-height: 6vh;
    font-size: 14px;
    color: #fff;
    margin-right: 20px;
    display: flex;
    position: absolute;
    right: 20px;
    div {
      flex: 1;
      // height: 6vh;
      // line-height: 6vh;
      display: flex;

      span {
        margin-top: 2.5vh;
        margin-right: 10px;
        display: block;
        height: 10px;
        width: 10px;
        border-radius: 5px;
        background-color: #fff;
      }
      .span1 {
        background-color: #fc941d;
      }
      .span2 {
        background-color: #fff;
      }
      .span3 {
        background-color: red;
      }
    }
  }
  .img {
    height: 8vh;
    img {
      height: 100%;
    }
  }
}
.maps {
  position: relative;
  height: 100vh;
  // height: 100%;
  width: 100%;
  background: url("../../../assets/cangku/bg.png") no-repeat;
  // overflow: hidden;
  // 头部
  // .title {
  //   height: 10vh;
  //   text-align: center;
  //   line-height: 10vh;
  //   width: 100%;
  //   color: #02faec;
  //   font-size: 30px;
  //   flex-wrap: 700;
  // }
  .content {
    height: 90vh;
    background-size: 100% 100%;
    display: flex;
    padding: 20px;
    box-sizing: border-box;
    overflow: hidden;
    flex-direction: column;

    .top {
      height: 60vh;
      width: 100%;
      // border: 1px solid #03f6e2;
      position: relative;
      overflow: hidden;
      overflow: scroll;
      background: url("../../../assets/znc/top.png") no-repeat ;
      background-size:100% 100%;

      .divCenter {
        position: relative;
        display: flex;
        flex-direction: column;
        .xianshiSolid {
          border: 2px solid red;
          height: 0;
          width: 100%;
          position: absolute;
          top: 0px;
        }

        .biankuang {
          // flex: 1;
          // min-height: 100px;
          color: rgb(233, 213, 36);
          font-weight: 700;
          border-bottom: 1px dashed #ccc;
        }
        .tianche {
          height: 100%;
          width: 2px;
          background-color: rgb(60, 206, 243);
          position: absolute;
          left: 20px;
          z-index: 22222;

          .circle1 {
            width: 20px;
            height: 10px;
            border-radius: 10px 10px 0 0;
            line-height: 10px;
            position: absolute;
            bottom: 0;
            left: -10px;
            background-color: rgb(60, 206, 243);
          }
          .circle2 {
            width: 15px;
            height: 20px;
            background-color: rgb(248, 231, 76);
            position: absolute;
            // top: -7.5px;
            left: -7.5px;
            border-radius: 5px;
          }
          .circle3 {
            width: 20px;
            height: 10px;
            border-radius: 0 0px 10px 10px;
            line-height: 10px;
            position: absolute;
            top: 0;
            left: -10px;

            background-color: rgb(60, 206, 243);
          }
        }

        .gangjuan {
          position: absolute;
          left: 0;
          width: 100%;
          height: 100%;
          // background-color: pink;
          .b1 {
            position: absolute;
            left: 0;
            top: 0;
            // width: 10px;
            // height: 10px;
            // border-radius: 5px;
            background-color: #fff;
            border: 2px solid #ccc;
            z-index: 1000;
            background: url("../../../assets/znc/正常卷.png") no-repeat;
            background-size: 100%;
          }
          .active {
            position: absolute;
            left: 0;
            top: 0;
            // width: 10px;
            // height: 10px;
            // border-radius: 5px;
            background-color: red;
            border: 2px solid #ccc;
            z-index: 1000;
            background: url("../../../assets/znc/预出卷.png") no-repeat;
            background-size: cover;
          }
          .active1 {
            position: absolute;
            left: 0;
            top: 0;
            // width: 10px;
            // height: 10px;
            // border-radius: 5px;
            background-color: #f37b1d;
            border: 2px solid #f37b1d;
            z-index: 1000;
            background: url("../../../assets/znc/基准卷.png") no-repeat;
            background-size: 100%;

            //  border: 2px solid #F37B1D;
            //  background: #F37B1D;
            //  z-index: 11111;
          }
        }
      }
    }
    .center {
      height: 1vh;
      width: 100%;
    }
    .bottom {
      height: 28vh;
      width: 100%;
      position: relative;
      overflow-y: scroll;
      background: url("../../../assets/znc/bot.png") no-repeat;
      background-size: 100%;
      .xianshiLayer {
        position: absolute;
        right: 200px;
        margin-top: 30px;
        color: #fff;
      }
      .el-icon-help {
        color: #f37b1d;
      }
      .tianche {
        height: 100%;
        width: 2px;
        background-color: rgb(60, 206, 243);
        position: absolute;
        left: 20px;
        z-index: 22222;

        .circle1 {
          width: 20px;
          height: 10px;
          border-radius: 10px 10px 0 0;
          line-height: 10px;
          position: absolute;
          bottom: 0;
          left: -10px;
          background-color: rgb(60, 206, 243);
        }
        .circle2 {
          width: 15px;
          height: 20px;
          background-color: rgb(248, 231, 76);
          position: absolute;
          top: 30px;
          left: -7.5px;
          border-radius: 5px;
        }
        .circle3 {
          width: 20px;
          height: 10px;
          border-radius: 0 0px 10px 10px;
          line-height: 10px;
          position: absolute;
          top: 0;
          left: -10px;

          background-color: rgb(60, 206, 243);
        }
      }

      .pingJuan {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        // padding-top: 6vh;
        // box-sizing: border-box;
        .one {
          position: absolute;
          bottom: 2vh;
        }
        .b1 {
          position: absolute;
          left: 0;
          bottom: 0;
          border-radius: 50%;
          border: 6px solid #fff;
          z-index: 1000;
          text-align: center;
        }
        .active {
          text-align: center;

          position: absolute;
          left: 0;
          bottom: 0;
          border-radius: 50%;
          border: 6px solid red;
          z-index: 1000;
        }
        .active1 {
          text-align: center;

          position: absolute;
          left: 0;
          bottom: 0;
          border-radius: 50%;
          border: 6px solid #f37b1d;
          z-index: 1000;
        }
        el-popover {
          z-index: 22222 !important;
        }
      }
    }
  }
  /*滚动条样式*/

  .top::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .top::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 2px #fff;
    background: #fff;
  }
  .top::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  .bottom::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .bottom::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 2px #fff;
    background: #fff;
  }
  .bottom::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
  /deep/ .el-input--suffix .el-input__inner {
    padding-right: 50px;
  }
  /deep/.el-input__inner {
    color: #fff;
    background-color: #354165;
    border: none;
  }
  /*滚动条样式*/

  .chepaiList::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  .chepaiList::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 2px #fff;
    background: #fff;
  }
  .chepaiList::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>
